export interface NotificationDto {
  message?: string,
  type?: string,
  id?: string,
}

export const notificationInit: NotificationDto = { message: undefined, type: undefined, id: undefined };